PageVue
  template(v-slot:body)
    LoginFormVue
